import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.patient-contact-data-update': {
         additionalInformation:
            'Dane zostaną zapisane w kartotece pacjenta i będą służyły do komunikacji z pacjentem w celu przeprowadzenia wideokonsultacji.',
         email: 'Adres e-mail',
         fillInPatientEmail: 'Uzupełnij adres e-mail pacjenta...',
         phoneNumber: 'Numer telefonu',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.patient-contact-data-update'
);
